<template>
  <div>
    <a-form-model
      v-if="!message"
      ref="form"
      :model="formRequest"
      :rules="rules"
      class="dedicated-request"
      @submit.prevent="submitHandler"
    >
      <a-form-model-item
        ref="name"
        class="dedicated-request__field"
        prop="name"
      >
        <a-input
          v-model="formRequest.name"
          :disabled="isDisabledForm"
          placeholder="Имя*"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item
        ref="email"
        class="dedicated-request__field"
        prop="email"
      >
        <a-input
          v-model="formRequest.email"
          :disabled="isDisabledForm"
          placeholder="Email*"
        ></a-input>
      </a-form-model-item>
      <a-form-model-item
        ref="phone"
        class="dedicated-request__field"
        prop="phone"
      >
        <a-input
          v-model="formRequest.phone"
          :disabled="isDisabledForm"
          placeholder="Телефон*"
        ></a-input>
      </a-form-model-item>

      <div class="dedicated-request__selectors">
        <a-form-model-item
          ref="city"
          class="dedicated-request__field"
          prop="city"
        >
          <span class="dedicated-request__selectors-title">Регион</span>
          <a-select
            v-model="formRequest.locations[0]"
          >
            <a-select-option
              v-for="location in locations"
              :key="location"
              :value="location"
            >
              {{ location }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          ref="quantity"
          class="dedicated-request__field"
          prop="quantity"
        >
          <span class="dedicated-request__selectors-title">Количество серверов</span>

          <a-input-number
            v-model="formRequest.quantity"
            :default-value="formRequest.quantity"
            :min="1"
            :max="1000"
            :formatter="value => inputNumberValidateSteps(value, 1, 1000)"
            :parser="value => inputNumberValidateSteps(value, 1, 1000)"
          ></a-input-number>
        </a-form-model-item>
      </div>

      <a-form-model-item
        ref="isAgree"
        class="dedicated-request__field dedicated-request__field--agreement"
        prop="isAgree"
      >
        <a-checkbox
          v-model="formRequest.isAgree"
          :disabled="isDisabledForm"
        >
          Я даю Согласие на обработку персональных данных на&nbsp;условиях, определенных
          <nuxt-link
            :to="localePath('/about/documents/personal-data/')"
            rel="noopener noreferrer"
            target="_blank"
          >
            Политикой
          </nuxt-link>
        </a-checkbox>
      </a-form-model-item>
      <button
        class="dedicated-request__submit btn btn--dark btn--lg"
        :disabled="isDisabledForm"
        type="submit"
      >
        Отправить заявку
      </button>
    </a-form-model>

    <div
      v-else
      class="dedicated-request__message"
      v-html="message"
    ></div>
  </div>
</template>

<script>
import RestClient from '~/rest-client'
import InputNumberValidate from '~/mixins/input-number-validate'

const restClient = new RestClient()

const locations = [
  'MSK-1',
  'MSK-2',
  'SPB-3',
  'SPB-4',
  'SPB-5'
]

export default {
  name: 'DedicatedRequest',
  mixins: [InputNumberValidate],
  props: {
    server: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      formRequest: {
        comment: this.server.name,
        quantity: 1,
        seidoUuid: this.server.uuid,
        locations: ['MSK-1'],
        name: null,
        email: null,
        phone: null,
        isAgree: null
      },
      locations,
      message: null,
      isDisabledForm: false,
      isSuccessfulRequest: false,
      rules: {
        name: [
          {
            required: true,
            message: 'Введите имя',
            transform: value => (
              value
                ? value.replace(/\s/g, '')
                : ''
            ),
            trigger: 'blur'
          }
        ],
        email: [
          {
            type: 'email',
            message: 'Введите корректный e-mail',
            trigger: 'blur'
          },
          {
            required: true,
            message: 'Введите e-mail',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            pattern: /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/,
            message: 'Введите корректный номер',
            trigger: 'blur'
          },
          {
            required: true,
            message: 'Введите номер',
            trigger: 'blur'
          }
        ],
        isAgree: [
          {
            type: 'enum',
            enum: [true],
            required: true,
            message: 'Подтвердите согласие на обработку персональных данных',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    serverName() {
      this.formRequest.comment = this.serverName
    }
  },
  methods: {
    async submitHandler() {
      await this.$refs.form.validate(async isValidForm => {
        if (!isValidForm) return false

        await this.makeRequests()
      })
    },
    async makeRequests() {
      await Promise
        .all([
          restClient.proxy.amocrm.post(this.formRequest)
        ])
        .then(() => {
          this.message = 'Как только сервер нужной конфигурации появится в наличии, мы обязательно вам сообщим.'
          this.isSuccessfulRequest = true
          this.$emit('submitForm', this.isSuccessfulRequest)
        })
        .catch(() => {
          this.message = 'Ошибка соединения. <br> Попробуйте повторить запрос позже.'
        })
    }
  }
}
</script>

<style lang="scss">
.dedicated-request {
  margin-bottom: -24px;

  .ant-input-number-handler-wrap {
    z-index: unset;
  }
}
.dedicated-request__message {
  margin-bottom: 40px;

  @media (max-width: $breakpoint-sm) {
    margin-bottom: 24px;
  }
}

.dedicated-request__field {
  @media (max-width: $breakpoint-sm) {
    margin-bottom: 16px;
  }

  &--agreement {
    margin-bottom: 24px;

    .ant-checkbox {
      @media (max-width: $breakpoint-sm) {
        top: 3px;
      }
    }
  }
}

.dedicated-request__selectors {
  margin-top: -8px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;

  @media (max-width: $breakpoint-md) {
    grid-template-columns: 1fr;
    grid-gap: 0;
    margin-bottom: 8px;
    margin-top: 0;
  }
}

.dedicated-request__selectors-title {
  color: $primary;
  display: block;
  margin-bottom: 4px;
}

.dedicated-request__submit {
  @media (max-width: $breakpoint-sm) {
    width: 100%;
  }
}
</style>